import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appDualZoneFooter]',
  standalone: true,
})
export class DualZoneFooterDirective {

  constructor(public tplRef: TemplateRef<any>) { }

}
